import axios from "axios";
import React, {useEffect, useState} from "react";
import Swal from "sweetalert2";
import ERPDataGrid from "../ERPDataGrid";
import "../ERPTheme.css";
import {baseUrl, ipAddress, userName} from "../Univ";
function CropCategory() {
    const [rows, setRows] = useState([]);
    const [loading, setLoading] = useState(false);
    const [formData, setFormData] = useState({
        name: "",
        description: ""
    });
    useEffect(() => {
        fetchData();
    }, []);
    const fetchData = () => {
        setLoading(true);
        axios.get(
            baseUrl + "crop-category/"
        )
            .then((res) => {
                setRows(res.data);
                setLoading(false);
            })
            .catch((err) => {
                console.log(err);
                setLoading(false);
            });
    };
    const handleChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value
        });
    };
    const formSubmit = (e) => {
        e.preventDefault();
        if (!formData.name) {
            Swal.fire(
                "Error",
                "Enter Category Name",
                "error"
            );
            return;
        }
        const fd = new FormData();
        fd.append(
            "name",
            formData.name
        );
        fd.append(
            "description",
            formData.description
        );
        fd.append(
            "status",
            "1"
        );
        fd.append(
            "addedby",
            userName
        );
        fd.append(
            "ip_add",
            ipAddress
        );
        axios.post(
            baseUrl + "crop-category/",
            fd
        )
            .then(() => {
                Swal.fire(
                    "Success",
                    "Crop Category Saved",
                    "success"
                );
                fetchData();
                setFormData({
                    name: "",
                    description: ""
                });
                setTimeout(() => {
                    window.location.reload();
                }, 2000);
            })
            .catch((err) => {
                console.log(err);
                Swal.fire(
                    "Error",
                    "Unable to Save",
                    "error"
                );
            });
    };
    const handleDelete = (id) => {
        Swal.fire({
            title: "Delete?",
            text: "Confirm Delete",
            icon: "warning",
            showCancelButton: true
        })
            .then((result) => {
                if (result.isConfirmed) {
                    axios.delete(
                        baseUrl +
                        "delete-crop-category/" +
                        id +
                        "/"
                    )
                        .then(() => {
                            Swal.fire(
                                "Deleted",
                                "",
                                "success"
                            );
                            fetchData();
                        });
                }
            });
    };
    const columns = [
        {
            field: "id",
            headerName: "ID",
            width: 70
        },
        {
            field: "name",
            headerName: "Category",
            flex: 1
        },
        {
            field: "description",
            headerName: "Description",
            flex: 2
        },
        {
            field: "delete",
            headerName: "Action",
            width: 120,
            renderCell: (params) => (
                <button

                    className="btn btn-danger btn-sm"

                    onClick={() =>
                        handleDelete(
                            params.row.id
                        )
                    }

                >

                    Delete

                </button>
            )
        }
    ];
    return (
        <section className="container-fluid mt-4">

            <div className="card">

                <h4 className="card-header">

                    Crop Category

                </h4>

                <div className="card-body">

                    <input

                        type="text"

                        name="name"

                        value={formData.name}

                        onChange={handleChange}

                        className="form-control mb-3"

                        placeholder="Category Name"

                    />

                    <textarea

                        name="description"

                        value={formData.description}

                        onChange={handleChange}

                        className="form-control mb-3"

                        placeholder="Description"

                    />

                    <button

                        onClick={formSubmit}

                        className="btn btn-primary"

                    >

                        Save

                    </button>

                </div>

            </div>

            <ERPDataGrid

                sx={{
                    boxShadow: 4,
                    border: 4,
                    borderColor: "primary.light",
                    "& .MuiDataGrid-cell:hover": {
                        color: "primary.main"
                    }
                }}

                className="mt-4"

                rows={rows}

                columns={columns}

                loading={loading}

                autoHeight

                pageSizeOptions={[10, 25, 50, 100]}

            />

        </section>
    );
}
export default CropCategory;